import React from "react";
var __jsx = React.createElement;
import stl from "./CustomInput.module.css";
import { CDN_LINK } from "@globalConfig";
import { useTranslation } from "@i18n";
var CustomInput = function CustomInput(_ref) {
  var label = _ref.label,
    name = _ref.name,
    className = _ref.className,
    error = _ref.error,
    isValid = _ref.isValid,
    ErrorInCode = _ref.ErrorInCode,
    ErrorMsg = _ref.ErrorMsg,
    currency = _ref.currency,
    referralMsg = _ref.referralMsg,
    type = _ref.type,
    placeholder = _ref.placeholder,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? "" : _ref$value,
    maxLength = _ref.maxLength,
    onPaste = _ref.onPaste,
    onKeyDown = _ref.onKeyDown,
    onKeyUp = _ref.onKeyUp,
    options = _ref.options,
    selected = _ref.selected,
    hasButton = _ref.hasButton,
    buttonText = _ref.buttonText,
    buttonFunction = _ref.buttonFunction,
    resetCode = _ref.resetCode,
    handleChange = _ref.handleChange;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.parentContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: [stl.container, className, isValid ? stl.isValid : undefined, ErrorInCode ? stl.ErrorInCode : undefined, error ? stl.borderErr : undefined].join(" ")
  }, /*#__PURE__*/React.createElement("label", null, label), type === "select" ? /*#__PURE__*/React.createElement("select", {
    name: name,
    onChange: function onChange(e) {
      return handleChange(e.target.value);
    },
    value: selected || ""
  }, !(options !== null && options !== void 0 && options.length) && /*#__PURE__*/React.createElement("option", {
    value: "",
    disabled: true
  }, t("اختر", {
    ns: "web_common"
  })), options === null || options === void 0 ? void 0 : options.map(function (opt, idx) {
    return /*#__PURE__*/React.createElement("option", {
      value: opt.id,
      key: idx + "opt"
    }, opt.name);
  })) : /*#__PURE__*/React.createElement("input", {
    name: name,
    type: type,
    placeholder: placeholder,
    value: value || "",
    autoComplete: "off",
    maxLength: maxLength,
    onPaste: onPaste,
    onKeyDown: onKeyDown,
    onKeyUp: onKeyUp,
    onChange: function onChange(e) {
      return handleChange(e.target);
    }
  }), hasButton && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    onClick: !isValid ? buttonFunction : resetCode,
    className: stl.innerBtn
  }, ErrorInCode ? ErrorMsg : !isValid ? buttonText : t("إزالة الخصم", {
    ns: "web_checkout_cash"
  }))), currency && /*#__PURE__*/React.createElement("span", {
    className: stl.curn
  }, currency)), error && /*#__PURE__*/React.createElement("div", {
    className: [stl.hasError, stl.err].join(" ")
  }, error), isValid && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.dicountShapeContainer
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/post_check_mark.svg",
    alt: "discount"
  }), /*#__PURE__*/React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: referralMsg || ""
    }
  })))));
};
export default CustomInput;